document.addEventListener("DOMContentLoaded", function() {
    if (window.headerInitialized) return;
    window.headerInitialized = true;
  
    // Parameter headers implementation
    const parameterHeaders = document.querySelectorAll('.parameter-header');
    parameterHeaders.forEach(header => {
        console.log('Processing parameter header:', header);
        
        header.addEventListener('click', function() {
            const content = this.nextElementSibling.querySelector('.parameters-child-content');
            if (content) {
                console.log('Content HTML before toggle:', content.outerHTML);
                
                // Toggle aria-expanded
                const isExpanded = this.getAttribute('aria-expanded') === 'true';
                this.setAttribute('aria-expanded', !isExpanded);
                
                // Toggle content visibility
                content.classList.toggle('show');
                
                console.log('Content HTML after toggle:', content.outerHTML);
            }
        });
    });

    // Add the new attribute toggle functionality
    window.toggleAttributes = function(button) {
        console.log('Toggle attributes clicked');
        const content = button.closest('.attribute-dropdown')
                             .querySelector('.attribute-content');
        const isShowing = content.classList.toggle('show');
        button.textContent = isShowing ? 'Hide Attributes' : 'Show Attributes';
        console.log('Attributes visibility:', isShowing);
    };
});